import filtersCarouselList from './filtersConfiguration';
import { MINIMUM_FILTER_INVENTORY } from './constants';

export const reorderList = (tilesOrder, topBarFilterOptions, stepIndex) => {
    const ordered = [];
    tilesOrder.forEach((tile) => {
        const filter = topBarFilterOptions.find((subCatFilter) => tile === subCatFilter.id);
        const hasMinimumInventory = filter && filter.count >= MINIMUM_FILTER_INVENTORY;

        if ((filter && stepIndex > 0) || (stepIndex === 0 && hasMinimumInventory)) {
            ordered.push(filter);
        }
    });

    return ordered;
};

export const isNextFilterAvailable = (nextFilter, availableFilters) => !!availableFilters.find((el) => el.id === nextFilter.id);

export const isNextStepExists = (nextFilter, availableFilters, isNextFilterSelected) => isNextFilterAvailable(nextFilter, availableFilters) && !isNextFilterSelected;

const findLatestActiveFilter = (filterTiles, activeFiltersKeys = []) => {
    let shouldStop = false;
    let latestActive = -1;

    for (let i = filterTiles.length - 1; i >= 0 && !shouldStop; i--) {
        const isActiveFilter = activeFiltersKeys.includes(filterTiles[i].id);

        if (isActiveFilter) {
            latestActive = i;
            shouldStop = true;
        }
    }
    return latestActive;
};

const findNextInactiveFilter = (nextStep, filterTiles, activeFiltersKeys, topBarFilterIdList) => {
    let counter = 0;
    while (counter < filterTiles.length) {
        nextStep = (nextStep + 1) % filterTiles.length;
        const currentFilter = filterTiles[nextStep];
        const isActiveFilter = activeFiltersKeys.includes(currentFilter.id);
        counter++;

        if (!isActiveFilter && topBarFilterIdList.includes(currentFilter.id)) {
            break;
        }
    }

    if (counter === filterTiles.length) {
        return -1;
    }

    return nextStep;
};

export const findStepIndex = (filterTiles, activeFiltersKeys, topBarFilterIdList) => {
    const latestActive = findLatestActiveFilter(filterTiles, activeFiltersKeys);
    return latestActive === -1 ? 0 :
        findNextInactiveFilter(latestActive, filterTiles, activeFiltersKeys, topBarFilterIdList);
};

export const getFilterTilesCarousel = (subCategoryId, nestedSubCategoryId) => filtersCarouselList.find((el) => el.id === subCategoryId || el.id === nestedSubCategoryId);
